// Module
var code = "<template>\n  <require from=\"./pen-order-details-container\"></require>\n  <pen-order-details-container pen-order-id.bind=\"data.penOrderId\" pen-id.bind=\"data.penId\"></pen-order-details-container>\n</template>\n";
// Exports
export default code;